<newsletter-svg-sprite />

<div [formGroup]="form" class="newsletter-form" [ngStyle]="{ background: brand?.primaryColor }"
  *ngIf="(newsletter$ | async) as newsletter" [ngClass]="{popup: mode == 'popup', 'home-page': mode == 'home-page'}">
  <div class="container">
    <h3 class="page-title">{{newsletter.callToAction ? newsletter.callToAction :
      ('newsLetter.subscribeToOurNewsletter' | translate)}}</h3>
    <div class="spam-msg d-flex justify-content-center align-items-center">

      <div class="icon">
        <svg>
          <use xlink:href="#unsubscribeIcon"></use>
        </svg>
      </div>
      <span class="spam-msg-txt">{{newsletter.infoNote ? newsletter.infoNote : ('newsLetter.defaultDisclaimer' |
        translate)
        }}</span>
    </div>

    <div class="email-wrapper d-flex align-items-center">
      <div class="form-group w-100">
        <input type="text" class="form-control" placeholder="{{('newsLetter.enterYourEmail' | translate)}}"
          formControlName="email">

      </div>
      <button class="btn-accent" (click)="saveEmail()">
        <span>{{ 'newsLetter.subscribe' | translate }}</span>
      </button>
    </div>

    <div class="checkbox-container d-flex align-items-center">
      <!-- <mat-checkbox color="primary" #consentWarning>
      </mat-checkbox> -->
      <div class="form-checkbox">
        <input formControlName="checkbox" type="checkbox" class="form-checkbox-input"
          [ngStyle]="{  accentColor: brand?.accentColor }" #consentWarning>
      </div>
      <span class="consent-warning noselect" (click)="toggle(consentWarning)">
        {{newsletter.consentWarning ? newsletter.consentWarning : ('newsLetter.defaultConsentNotice' | translate)}}
      </span>
    </div>
  </div>
  <img class="bg-send-img" [src]="newsletterUrl" alt="">
</div>